"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormulaTokenizer = void 0;
const constant_1 = require("../constant");
/**
 * The FormulaTokenizer class is responsible for tokenizing and formatting
 * mathematical expressions for further evaluation. It handles the input
 * string by formatting it, filtering tokens, and preparing them for processing.
 */
class FormulaTokenizer {
    /**
     * Formats the input string by replacing operators and trimming whitespace.
     * @param {string} input The input string to be formatted.
     * @returns {string} The formatted expression.
     */
    formatInput(input) {
        return input
            .replace(constant_1.REGEX.formulaOperatorG, " $1 ")
            .replace(/\s+/g, " ")
            .trim();
    }
    /**
     * Filters the tokens to handle numbers and operators appropriately.
     * This method processes the tokens to ensure that numbers and operators
     * are in the correct format for evaluation.
     * @param {string[]} tokens The array of tokens to be filtered.
     * @returns {(string | number)[]} The filtered tokens as an array of strings and numbers.
     */
    filterTokens(tokens) {
        const filteredTokens = [];
        let expectedClosedParenthesis = false;
        tokens.forEach((token) => {
            const regex = /^\d+(\.\d+)?$/;
            const negativeNumberRegex = /-\d+/;
            const lastFilteredToken = filteredTokens[filteredTokens.length - 1];
            if (regex.test(token)) {
                const firstPop = filteredTokens.pop();
                const secondPop = filteredTokens.pop();
                if (firstPop != undefined && secondPop != undefined) {
                    if (constant_1.Priority_1_Operator.includes(firstPop) &&
                        secondPop === constant_1.ParenthesisOpenOperator) {
                        filteredTokens.push(Number(firstPop + token));
                        expectedClosedParenthesis = true;
                    }
                    else {
                        filteredTokens.push(secondPop, firstPop, Number(token));
                    }
                }
                else {
                    if (secondPop == undefined) {
                        if (firstPop != undefined) {
                            filteredTokens.push(firstPop, Number(token));
                        }
                        else {
                            filteredTokens.push(Number(token));
                        }
                    }
                    else {
                        filteredTokens.push(Number(token));
                    }
                }
            }
            else if (negativeNumberRegex.test(lastFilteredToken) &&
                token === constant_1.ParenthesisCloseOperator &&
                expectedClosedParenthesis) {
                expectedClosedParenthesis = false;
            }
            else {
                filteredTokens.push(token);
            }
        });
        return filteredTokens;
    }
    /**
     * Executes the tokenization process for the given input string.
     * This method formats the input, splits it into tokens,
     * and filters the tokens to produce a final result.
     * @param {string} input The input string to be tokenized.
     * @returns {any[]} The array of filtered tokens resulting from the tokenization process.
     */
    execute(input) {
        const formattedInput = this.formatInput(input);
        if (formattedInput.trim() === "")
            return [];
        const tokens = formattedInput.split(" ");
        const filteredTokens = this.filterTokens(tokens);
        return filteredTokens;
    }
}
exports.FormulaTokenizer = FormulaTokenizer;
